import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../../../assets/css/customer/services/ServicesHero.css';

const ServicesHero = () => {
  return (
     <section className="contact-hero-section">
         <Container>
           <div className="contact-hero-content">
             {/* Main Heading */}
             <h1 className="contact-hero-heading">Services</h1>
   
             {/* Description */}
             <p className="contact-hero-description">
               Plan your perfect wedding with our all-in-one event management services, designed to make your special day stress-free and memorable.
             </p>
           </div>
         </Container>
       </section>
  );
};

export default ServicesHero;